import {
  jpPickerMenu,
  provideJupyterDesignSystem
} from '@jupyter/web-components';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef
} from 'react';
import { useProperties } from './react-utils.js';
provideJupyterDesignSystem().register(jpPickerMenu());

export const PickerMenu = forwardRef((props, forwardedRef) => {
  const ref = useRef(null);
  const { className, suggestionsAvailableText, ...filteredProps } = props;

  /** Properties - run whenever a property has changed */
  useProperties(
    ref,
    'suggestionsAvailableText',
    props.suggestionsAvailableText
  );

  /** Methods - uses `useImperativeHandle` hook to pass ref to component */
  useImperativeHandle(forwardedRef, () => ref.current, [ref.current]);

  return React.createElement(
    'jp-draft-picker-menu',
    {
      ref,
      ...filteredProps,
      class: props.className,
      exportparts: props.exportparts,
      for: props.htmlFor,
      part: props.part,
      tabindex: props.tabIndex,
      style: { ...props.style }
    },
    props.children
  );
});
